import { render, staticRenderFns } from "./PatientInvoices.vue?vue&type=template&id=6d14cef6&"
import script from "./PatientInvoices.vue?vue&type=script&lang=js&"
export * from "./PatientInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports